import { deepClone } from '@/utils'
export default {
  props: {
    //值
    value: {
      type: [Array, Object, String, Number, Boolean]
    },
    // 问题结构 非一定注入
    item: {
      type: Object,
      default: () => {}
    },
    // 考试
    examConfig: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      config: null,
      changeValue: this.value,
      curSelectedOption: '',
      keyWords: '',
      options: [],
      initValue: this.value === '' || this.value === null ? 0 : this.value //由于评分、数字、滑块组件会自动把空值转成0，因此先绑定一个中间变量，当用户操作之后才去赋值
    }
  },
  computed: {},
  created() {
    if (this.item) {
      this.config = this.item.config
      this.options = deepClone(this.item.config.options)
    }
  },
  watch: {
    changeValue(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.changeValue = val
    }
  },
  mounted() {},
  methods: {
    getOptions() {
      return this.item.config.options
    },
    handleSearch() {
      const { item, keyWords } = this
      if (this.$refs.selectBody)
        this.$nextTick(() => {
          this.$refs.selectBody.scrollTop = 0
        })
      let filterOptions = []
      const { options } = item.config
      filterOptions = keyWords === '' ? options : options.filter((item) => item.label.includes(keyWords))
      this.options = filterOptions
    },
    handleClear() {
      this.handleSearch()
    },
    selectFocus(value) {
      this.curSelectedOption = value
    },
    optionExtensionChange(val, optionVal) {
      this.models[`${this.item.vModel}${'extension_' + optionVal}`] = val
      this.$emit('other-input-change', this.changeValue, this.item)
    },
    uploadLogoHandle(response, index) {
      const _config = this.item.config
      _config.options[index].optionImgUrl = response[response.length - 1].url
      this.$emit('upload-option-img', _config)
    },
    removeBgImgHandle(index) {
      const _config = this.item.config
      _config.options[index].optionImgUrl = ''
      this.$emit('upload-option-img', _config)
    }
  }
}
